import React from 'react';

import { ErrorBoundary } from '../../containers/ErrorBoundary';
import { EMPTY_FUNCTION } from '../../shared/constants';
import { FormattedMessageHelper } from '../../shared/helpers/internationalization';

import { MonacoEditorPlaceholder } from './MonacoEditorPlaceholder';

const ReactMonacoEditor = React.lazy(() => import('react-monaco-editor'));

interface AlphaMonacoProps {
  language: string;
  regular?: string;
  selection?: string;
  combo?: string;
  editorDidMount: any;
  editorWillMount: any;
  alphaId: string;
  type: string;
  maxVisibleLines?: number;
}

const AlphaMonaco = ({
  type,
  language,
  regular,
  selection,
  combo,
  editorDidMount,
  editorWillMount,
  alphaId,
  maxVisibleLines,
}: AlphaMonacoProps) => (
  <React.Fragment>
    {type === 'SUPER' && (
      <div className="editor-code__title--alpha-detail">
        <FormattedMessageHelper id="editor.selection.expression" />
      </div>
    )}

    <ErrorBoundary isNotFullScreen={true}>
      <React.Suspense
        fallback={<MonacoEditorPlaceholder code={type === 'SUPER' ? selection! : regular!} maxVisibleLines={maxVisibleLines} />}
      >
        <ReactMonacoEditor
          language={`${language}-${type === 'SUPER' ? 'selection' : 'regular'}`}
          value={type === 'SUPER' ? selection : regular}
          theme="vs-dark"
          editorDidMount={editorDidMount}
          editorWillMount={editorWillMount}
          editorWillUnmount={EMPTY_FUNCTION}
          key={`${type === 'SUPER' ? 'selection' : 'regular'}-${alphaId}`}
          options={{
            readOnly: true,
            lineHeight: 20,
            selectOnLineNumbers: true,
            scrollBeyondLastLine: false,
            minimap: { enabled: false },
          }}
        />
      </React.Suspense>
    </ErrorBoundary>

    {type === 'SUPER' && (
      <>
        <div className="editor-code__title--alpha-detail">
          <FormattedMessageHelper id="editor.combo.expression" />
        </div>

        <React.Suspense fallback={<MonacoEditorPlaceholder code={combo!} maxVisibleLines={maxVisibleLines} />}>
          <ReactMonacoEditor
            language={`${language}-combo`}
            value={combo}
            theme="vs-dark"
            editorDidMount={editorDidMount}
            editorWillMount={editorWillMount}
            editorWillUnmount={EMPTY_FUNCTION}
            key={`${alphaId}-combo`}
            options={{
              readOnly: true,
              lineHeight: 20,
              selectOnLineNumbers: true,
              scrollBeyondLastLine: false,
              minimap: { enabled: false },
            }}
          />
        </React.Suspense>
      </>
    )}
  </React.Fragment>
);

export default AlphaMonaco;
